import React from 'react';
import { ReadyState } from 'react-use-websocket';
import usePingPongTimeout from '../../../../Hooks/usePingPongTimeout';
import useAudioWebsocketApiConnectionContext from '../Contexts/WebsocketConnectionProviders/AudioWebsocketApiConnectionContext/useAudioWebsocketApiConnectionContext';

const INTERVAL = 3000;

export default function useAudioWebsocketConnectionLiveliness() {
  const {
    sendJsonMessage,
    lastJsonMessage,
    readyState,
    restart,
  } = useAudioWebsocketApiConnectionContext();

  const sendPing = React.useCallback(() => {
    sendJsonMessage({
      type: 'ping',
      date: Date.now() * 1e6,
    });
  }, [sendJsonMessage]);

  const onTimeout = React.useCallback(() => {
    console.error('Connection to audio websocket timed out, restarting connection');
    restart();
  }, [restart]);

  const { onPongReceived } = usePingPongTimeout({
    enabled: readyState === ReadyState.OPEN,
    timeoutMs: INTERVAL,
    intervalMs: INTERVAL,
    sendPing,
    onTimeout,
  });

  React.useEffect(() => {
    if (lastJsonMessage && lastJsonMessage.type === 'pong') {
      onPongReceived();
    }
  }, [lastJsonMessage, onPongReceived]);
}
